// Source: https://github.com/vuex-orm/vuex-orm/issues/714#issuecomment-810631707
export default {
    install(components) {
        components.MorphMany.prototype.attach = function MorphMany(key, record, data) {
            const relatedItems = data[this.related.entity];

            key.forEach(id => {
                const relatedItem = relatedItems[id];

                relatedItem[this.id] = relatedItem[this.id] || this.model.getIdFromRecord(record);
                relatedItem[this.type] = relatedItem[this.type] || this.model.entity;
            });
        };
    },
};
